import { display, width } from "@mui/system";
import React, { useState, useRef, useEffect } from "react";
import { View, Text, StyleSheet, ScrollView, SafeAreaView, ActivityIndicator, Modal, Pressable, TouchableOpacity, Image } from "react-native";
import { Picker, SectionList } from "react-native-web";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Icon from 'react-native-vector-icons/FontAwesome';
import { useTranslation } from 'react-i18next';
import { i18n } from '../assets/lang/i18next';
import { Dimensions } from 'react-native';
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const useStyles = makeStyles(() => ({
    textField: {
        width: "100%",
        marginTop: 20,
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: 0,
        marginTop: 0,
        fontWeight: 500,
        fontSize: 13,
        direction: "rtl",
        "& .MuiFormLabel-root": {
            color: "black",
            textAlign: 'right',
            fontFamily: 'IranSans',
            fontSize: 13, direction: 'rtl', width: '100%',
        },
        "& .MuiInputLabel-asterisk": {
            color: 'red',
            fontWeight: 900,
        },
        "& .MuiInputBase-input": {
            color: '#333', textAlign: 'center'
        },
        '& label.Mui-focused': {
            color: '#333',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'yellow',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'white',
            },
            '&:hover fieldset': {
                borderColor: 'blue',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#333',
            },
        },

    },
    labelRoot: {
        right: 20,
    },
    shrink: {
        transformOrigin: "top right",
    },
    input: {
        color: "black", fontFamily: 'IranSans',
        fontSize: 13,

    },
    btn_calculate: {
        color: '#333',
        backgroundColor: 'gray',
        fontFamily: 'IranSans',
        fontSize: 13, fontWeight: 900,
    }
}));
const CompCondonser = props => {
    const { t, i18n } = useTranslation();
    const componentRef = useRef();
    const classes = useStyles();
    const [modalVisible, setModalVisible] = useState(false);
    const [errorlist, SetErrorList] = useState("");
    const [itemsCond1, setCond1Items] = useState([]);
    const [itemsCond2, setCond2Items] = useState([]);
    const [datacondonser, setCondonserData] = useState(() => { item => setCondonserData(item) });

    const [wd, setwd] = useState('block');


    React.useEffect(() => {

        if (Dimensions.get('window').width < 600)
            setwd('none');
        else
            setwd('block');



    }, [Dimensions.get('window').width]);
    const [zarfiyatnami, setzarfiyatnami] = useState("-");
    const [faselefin, setfaselefin] = useState("-");
    const [sathtabadolhararat, setsathtabadolhararat] = useState("-");
    const [gazgiri, setgazgiri] = useState("-");
    const [tedadfan, settedadfan] = useState("-");
    const [debi, setdebi] = useState("-");
    const [vorodi, setvorodi] = useState("-");
    const [khoroji, setkhoroji] = useState("-");
    const [vazn, setvazn] = useState("-");
    const [sorat, setsorat] = useState("-");
    const [ip, setip] = useState("-");
    const [voltajfan, setvoltajfan] = useState("-");
    const [ferekans, setferekans] = useState("-");
    const [jaryanfan, setjaryanfan] = useState("-");
    const [tavanfan, settavanfan] = useState("-");
    const [vorodireciver, setvorodireciver] = useState("-");
    const [khorojireciver, setkhorojireciver] = useState("-");
    const [ghotrefan, setghotrefan] = useState("-");
    const [urlshematic, seturlshematic] = useState("-");



    const [zarfiyatnami2, setzarfiyatnami2] = useState("-");
    const [faselefin2, setfaselefin2] = useState("-");
    const [sathtabadolhararat2, setsathtabadolhararat2] = useState("-");
    const [gazgiri2, setgazgiri2] = useState("-");
    const [tedadfan2, settedadfan2] = useState("-");
    const [debi2, setdebi2] = useState("-");
    const [vorodi2, setvorodi2] = useState("-");
    const [khoroji2, setkhoroji2] = useState("-");
    const [vazn2, setvazn2] = useState("-");
    const [sorat2, setsorat2] = useState("-");
    const [ip2, setip2] = useState("-");
    const [voltajfan2, setvoltajfan2] = useState("-");
    const [ferekans2, setferekans2] = useState("-");
    const [jaryanfan2, setjaryanfan2] = useState("-");
    const [tavanfan2, settavanfan2] = useState("-");
    const [vorodireciver2, setvorodireciver2] = useState("-");
    const [khorojireciver2, setkhorojireciver2] = useState("-");
    const [ghotrefan2, setghotrefan2] = useState("-");
    const [urlshematic2, seturlshematic2] = useState("-");


    const [zarfiyatnami3, setzarfiyatnami3] = useState("-");
    const [faselefin3, setfaselefin3] = useState("-");
    const [sathtabadolhararat3, setsathtabadolhararat3] = useState("-");
    const [gazgiri3, setgazgiri3] = useState("-");
    const [tedadfan3, settedadfan3] = useState("-");
    const [debi3, setdebi3] = useState("-");
    const [vorodi3, setvorodi3] = useState("-");
    const [khoroji3, setkhoroji3] = useState("-");
    const [vazn3, setvazn3] = useState("-");
    const [sorat3, setsorat3] = useState("-");
    const [ip3, setip3] = useState("-");
    const [voltajfan3, setvoltajfan3] = useState("-");
    const [ferekans3, setferekans3] = useState("-");
    const [jaryanfan3, setjaryanfan3] = useState("-");
    const [tavanfan3, settavanfan3] = useState("-");
    const [vorodireciver3, setvorodireciver3] = useState("-");
    const [khorojireciver3, setkhorojireciver3] = useState("-");
    const [ghotrefan3, setghotrefan3] = useState("-");
    const [urlshematic3, seturlshematic3] = useState("-");


    const [zarfiyatnami4, setzarfiyatnami4] = useState("-");
    const [faselefin4, setfaselefin4] = useState("-");
    const [sathtabadolhararat4, setsathtabadolhararat4] = useState("-");
    const [gazgiri4, setgazgiri4] = useState("-");
    const [tedadfan4, settedadfan4] = useState("-");
    const [debi4, setdebi4] = useState("-");
    const [vorodi4, setvorodi4] = useState("-");
    const [khoroji4, setkhoroji4] = useState("-");
    const [vazn4, setvazn4] = useState("-");
    const [sorat4, setsorat4] = useState("-");
    const [ip4, setip4] = useState("-");
    const [voltajfan4, setvoltajfan4] = useState("-");
    const [ferekans4, setferekans4] = useState("-");
    const [jaryanfan4, setjaryanfan4] = useState("-");
    const [tavanfan4, settavanfan4] = useState("-");
    const [vorodireciver4, setvorodireciver4] = useState("-");
    const [khorojireciver4, setkhorojireciver4] = useState("-");
    const [ghotrefan4, setghotrefan4] = useState("-");
    const [urlshematic4, seturlshematic4] = useState("-");

    const [isOpen, setIsOpen] = useState(false);
    const [currentimageclick, setcurrentimageclick] = useState("");

    function LISTCondonser() {
        fetch(`https://app.arshehkar.com/query/public/GetListCondonserFull.php`)
            .then(response => response.json())
            .then(async (datacondonser) => {
                const mapArray = datacondonser.map(({ model_title, id }) => ({ label: model_title, value: id }));
                setCond1Items(mapArray);
                if (datacondonser.length > 0) {
                    // Setmodelcomprosor(datacondonser[0]["title"]);
                }

            })
    }
    function GetInfoCondonser(idevap) {
        if (idevap != "" & idevap != 0) {
            fetch(`https://app.arshehkar.com/query/public/GetInfoCondonserById.php?id=${idevap}`)
                .then(response => response.json())
                .then(async (responseJsontmp) => {
                    setzarfiyatnami(responseJsontmp["zarfiyatnami"]);
                    setsathtabadolhararat(responseJsontmp["sathtabadolhararat"]);
                    setgazgiri(responseJsontmp["gazgiri"]);
                    settedadfan(responseJsontmp["tedadfan"]);
                    setdebi(responseJsontmp["debi"]);
                    setfaselefin(responseJsontmp["faselefin"]);
                    setvorodi(responseJsontmp["vorodi"]);
                    setkhoroji(responseJsontmp["khoroji"]);
                    setvazn(responseJsontmp["vazn"]);
                    setsorat(responseJsontmp["sorat"]);
                    setip(responseJsontmp["ip"]);
                    setvoltajfan(responseJsontmp["voltajfan"]);
                    setferekans(responseJsontmp["ferekans"]);
                    setjaryanfan(responseJsontmp["jaryanfan"]);
                    settavanfan(responseJsontmp["tavanfan"]);
                    setvorodireciver(responseJsontmp["vorodireciver"]);
                    setkhorojireciver(responseJsontmp["khorojireciver"]);
                    setghotrefan(responseJsontmp["ghotrefan"]);
                    seturlshematic(responseJsontmp["shematicboland"]);

                })
        }
        else {
            setzarfiyatnami("-");
            setsathtabadolhararat('-');
            setgazgiri("-");
            settedadfan("-");
            setdebi("-");
            setfaselefin("-");
            setvorodi("-");
            setkhoroji('-');
            setvazn("-");
            setsorat("-");
            setip("-");
            setvoltajfan("-");
            setferekans("-");
            setjaryanfan("-");
            settavanfan("-");
            setvorodireciver("-");
            setkhorojireciver("-");
            setghotrefan("-");
            seturlshematic("-");
        }


    }
    function GetInfoCondonser2(idevap) {
        if (idevap != "" && idevap != 0) {
            fetch(`https://app.arshehkar.com/query/public/GetInfoCondonserById.php?id=${idevap}`)
                .then(response => response.json())
                .then(async (responseJsontmp) => {
                    setzarfiyatnami2(responseJsontmp["zarfiyatnami"]);
                    setsathtabadolhararat2(responseJsontmp["sathtabadolhararat"]);
                    setgazgiri2(responseJsontmp["gazgiri"]);
                    settedadfan2(responseJsontmp["tedadfan"]);
                    setdebi2(responseJsontmp["debi"]);
                    setfaselefin2(responseJsontmp["faselefin"]);
                    setvorodi2(responseJsontmp["vorodi"]);
                    setkhoroji2(responseJsontmp["khoroji"]);
                    setvazn2(responseJsontmp["vazn"]);
                    setsorat2(responseJsontmp["sorat"]);
                    setip2(responseJsontmp["ip"]);
                    setvoltajfan2(responseJsontmp["voltajfan"]);
                    setferekans2(responseJsontmp["ferekans"]);
                    setjaryanfan2(responseJsontmp["jaryanfan"]);
                    settavanfan2(responseJsontmp["tavanfan"]);
                    setvorodireciver2(responseJsontmp["vorodireciver"]);
                    setkhorojireciver2(responseJsontmp["khorojireciver"]);
                    setghotrefan2(responseJsontmp["ghotrefan"]);
                    seturlshematic2(responseJsontmp["shematicboland"]);

                })
        }
        else {
            setzarfiyatnami2("-");
            setsathtabadolhararat2('-');
            setgazgiri2("-");
            settedadfan2("-");
            setdebi2("-");
            setfaselefin2("-");
            setvorodi2("-");
            setkhoroji2('-');
            setvazn2("-");
            setsorat2("-");
            setip2("-");
            setvoltajfan2("-");
            setferekans2("-");
            setjaryanfan2("-");
            settavanfan2("-");
            setvorodireciver2("-");
            setkhorojireciver2("-");
            setghotrefan2("-");
            seturlshematic2("-");

        }


    }
    function GetInfoCondonser3(idevap) {
        if (idevap != "" && idevap != 0) {
            fetch(`https://app.arshehkar.com/query/public/GetInfoCondonserById.php?id=${idevap}`)
                .then(response => response.json())
                .then(async (responseJsontmp) => {
                    setzarfiyatnami3(responseJsontmp["zarfiyatnami"]);
                    setsathtabadolhararat3(responseJsontmp["sathtabadolhararat"]);
                    setgazgiri3(responseJsontmp["gazgiri"]);
                    settedadfan3(responseJsontmp["tedadfan"]);
                    setdebi3(responseJsontmp["debi"]);
                    setfaselefin3(responseJsontmp["faselefin"]);
                    setvorodi3(responseJsontmp["vorodi"]);
                    setkhoroji3(responseJsontmp["khoroji"]);
                    setvazn3(responseJsontmp["vazn"]);
                    setsorat3(responseJsontmp["sorat"]);
                    setip3(responseJsontmp["ip"]);
                    setvoltajfan3(responseJsontmp["voltajfan"]);
                    setferekans3(responseJsontmp["ferekans"]);
                    setjaryanfan3(responseJsontmp["jaryanfan"]);
                    settavanfan3(responseJsontmp["tavanfan"]);
                    setvorodireciver3(responseJsontmp["vorodireciver"]);
                    setkhorojireciver3(responseJsontmp["khorojireciver"]);
                    setghotrefan3(responseJsontmp["ghotrefan"]);
                    seturlshematic3(responseJsontmp["shematicboland"]);


                })
        }
        else {
            setzarfiyatnami3("-");
            setsathtabadolhararat3('-');
            setgazgiri3("-");
            settedadfan3("-");
            setdebi3("-");
            setfaselefin3("-");
            setvorodi3("-");
            setkhoroji3('-');
            setvazn3("-");
            setsorat3("-");
            setip3("-");
            setvoltajfan3("-");
            setferekans3("-");
            setjaryanfan3("-");
            settavanfan3("-");
            setvorodireciver3("-");
            setkhorojireciver3("-");
            setghotrefan3("-");
            seturlshematic3("-");
        }



    }
    function GetInfoCondonser4(idevap) {
        if (idevap != "" && idevap != 0) {
            fetch(`https://app.arshehkar.com/query/public/GetInfoCondonserById.php?id=${idevap}`)
                .then(response => response.json())
                .then(async (responseJsontmp) => {
                    setzarfiyatnami4(responseJsontmp["zarfiyatnami"]);
                    setsathtabadolhararat4(responseJsontmp["sathtabadolhararat"]);
                    setgazgiri4(responseJsontmp["gazgiri"]);
                    settedadfan4(responseJsontmp["tedadfan"]);
                    setdebi4(responseJsontmp["debi"]);
                    setfaselefin4(responseJsontmp["faselefin"]);
                    setvorodi4(responseJsontmp["vorodi"]);
                    setkhoroji4(responseJsontmp["khoroji"]);
                    setvazn4(responseJsontmp["vazn"]);
                    setsorat4(responseJsontmp["sorat"]);
                    setip4(responseJsontmp["ip"]);
                    setvoltajfan4(responseJsontmp["voltajfan"]);
                    setferekans4(responseJsontmp["ferekans"]);
                    setjaryanfan4(responseJsontmp["jaryanfan"]);
                    settavanfan4(responseJsontmp["tavanfan"]);
                    setvorodireciver4(responseJsontmp["vorodireciver"]);
                    setkhorojireciver4(responseJsontmp["khorojireciver"]);
                    setghotrefan4(responseJsontmp["ghotrefan"]);
                    seturlshematic4(responseJsontmp["shematicboland"]);

                })
        }
        else {
            setzarfiyatnami4("-");
            setsathtabadolhararat4('-');
            setgazgiri4("-");
            settedadfan4("-");
            setdebi4("-");
            setfaselefin4("-");
            setvorodi4("-");
            setkhoroji4('-');
            setvazn4("-");
            setsorat4("-");
            setip4("-");
            setvoltajfan4("-");
            setferekans4("-");
            setjaryanfan4("-");
            settavanfan4("-");
            setvorodireciver4("-");
            setkhorojireciver4("-");
            setghotrefan4("-");
            seturlshematic4("-");
        }


    }
    LISTCondonser();
    return (
        <SafeAreaView style={styles.container}>
            <View style={styles.header}>
                <Text style={styles.titleheader}>{t('ComparisonCondenser')}</Text>
            </View>
            <View style={styles.formcomp}>
                <View style={styles.viewform}>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            GetInfoCondonser(itemValue);
                        }}

                    >
                        <Picker.Item label={t('select')} value="0" />
                        {itemsCond1.map((item, index) => {
                            return (
                                <Picker.Item
                                    key={index}
                                    label={item.label}
                                    value={item.value}
                                />
                            )
                        }
                        )
                        }
                    </Picker>
                </View>
                <View style={[styles.viewform, { marginLeft: 5 }]}>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            GetInfoCondonser2(itemValue);
                        }}
                    >
                        <Picker.Item label={t('select')} value="0" />
                        {itemsCond1.map((item, index) => {
                            return (
                                <Picker.Item
                                    key={index}
                                    label={item.label}
                                    value={item.value}
                                />
                            )
                        }
                        )
                        }
                    </Picker>
                </View>
                <View style={[styles.viewform, { marginLeft: 5, display: wd }]}>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            GetInfoCondonser3(itemValue);
                        }}
                    >
                        <Picker.Item label={t('select')} value="0" />
                        {itemsCond1.map((item, index) => {
                            return (
                                <Picker.Item
                                    key={index}
                                    label={item.label}
                                    value={item.value}
                                />
                            )
                        }
                        )
                        }
                    </Picker>
                </View>
                <View style={[styles.viewform, { marginLeft: 5, display: wd }]}>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            GetInfoCondonser4(itemValue);
                        }}
                    >
                        <Picker.Item label={t('select')} value="0" />
                        {itemsCond1.map((item, index) => {
                            return (

                                <Picker.Item
                                    key={index}
                                    label={item.label}
                                    value={item.value}
                                />
                            )
                        }
                        )
                        }
                    </Picker>
                </View>
            </View>


            <View style={[styles.form, { flexDirection: 'column', alignItems: 'center', marginTop: 20 }]}>
                <TouchableOpacity onPress={() => { setcurrentimageclick(urlshematic); setIsOpen(true) }}>
                    <Image style={{
                        width: 180, height: 180, resizeMode: 'contain',
                    }} source={urlshematic}
                    />
                </TouchableOpacity>
                <TouchableOpacity onPress={() => { setcurrentimageclick(urlshematic2); setIsOpen(true) }}>
                    <Image style={{
                        width: 180, height: 180, resizeMode: 'contain',
                    }} source={urlshematic2}
                    />
                </TouchableOpacity>
                <TouchableOpacity onPress={() => { setcurrentimageclick(urlshematic3); setIsOpen(true) }} style={{ display: wd }}>
                    <Image style={{
                        width: 180, height: 180, resizeMode: 'contain',
                    }} source={urlshematic3}
                    />
                </TouchableOpacity>
                <TouchableOpacity onPress={() => { setcurrentimageclick(urlshematic4); setIsOpen(true) }} style={{ display: wd }}>
                    <Image style={{
                        width: 180, height: 180, resizeMode: 'contain',
                    }} source={urlshematic4}
                    />
                </TouchableOpacity>
            </View>
            {isOpen && <Lightbox
                mainSrc={currentimageclick}
                onCloseRequest={() => { setIsOpen(false); }}
            />}


            <View style={styles.formheader}><Text style={styles.titleform}>{t("Nominalcapacity")} ({t("KW")})</Text></View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>{zarfiyatnami}</Text>
                <Text style={styles.titleform}>{zarfiyatnami2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{zarfiyatnami3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{zarfiyatnami4}</Text>

            </View>
            <View style={styles.formheader}>                <Text style={styles.titleform}>{t("surfaceareaofheattransfer")} ({t("M2")})</Text></View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>{sathtabadolhararat}</Text>
                <Text style={styles.titleform}>{sathtabadolhararat2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{sathtabadolhararat3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{sathtabadolhararat4}</Text>

            </View>
            <View style={styles.formheader}>                <Text style={styles.titleform}> {t("Circuitvol")} ({t("litre")})</Text></View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>{gazgiri}</Text>
                <Text style={styles.titleform}>{gazgiri2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{gazgiri3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{gazgiri4}</Text>

            </View>
            <View style={styles.formheader}>                <Text style={styles.titleform}> {t("Nooffans")} ({t("PCS")})</Text></View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>{tedadfan}</Text>
                <Text style={styles.titleform}>{tedadfan2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{tedadfan3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{tedadfan4}</Text>

            </View>
            <View style={styles.formheader}>                <Text style={styles.titleform}>{t("FanDiameter(cm)")}</Text></View>
            <View style={styles.form}>
                <Text style={styles.titleform}>{ghotrefan}</Text>
                <Text style={styles.titleform}>{ghotrefan2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{ghotrefan3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{ghotrefan4}</Text>

            </View>
            <View style={styles.formheader}>                <Text style={styles.titleform}>{t("Airflow")} ({t("m3hr")})</Text></View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>{debi}</Text>
                <Text style={styles.titleform}>{debi2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{debi3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{debi4}</Text>

            </View>
            <View style={styles.formheader}>                <Text style={styles.titleform}>{t("Finspace")} ({t("thickness")})</Text></View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>{faselefin}</Text>
                <Text style={styles.titleform}>{faselefin2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{faselefin3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{faselefin4}</Text>

            </View>
            <View style={styles.formheader}>                <Text style={styles.titleform}>{t("Inlet")} ({t("inch")})</Text></View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>{vorodi}</Text>
                <Text style={styles.titleform}>{vorodi2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{vorodi3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{vorodi4}</Text>

            </View>
            <View style={styles.formheader}>                <Text style={styles.titleform}>{t("Outlet")} ({t("inch")})</Text></View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>{khoroji}</Text>
                <Text style={styles.titleform}>{khoroji2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{khoroji3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{khoroji4}</Text>

            </View>
            <View style={styles.formheader}>                <Text style={styles.titleform}>{t("Weight")} ({t("kg")})</Text></View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>{vazn}</Text>
                <Text style={styles.titleform}>{vazn2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{vazn3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{vazn4}</Text>

            </View>



            <View style={styles.header}>
                <Text style={styles.titleheader}> {t("fanspecifications")}  </Text>
            </View>

            <View style={styles.formheader}>                <Text style={styles.titleform}>{t("speed")} ({t("RPM")})</Text></View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>{sorat}</Text>
                <Text style={styles.titleform}>{sorat2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{sorat3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{sorat4}</Text>

            </View>


            <View style={styles.formheader}>                <Text style={styles.titleform}>IP</Text></View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>{ip}</Text>
                <Text style={styles.titleform}>{ip2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{ip3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{ip4}</Text>

            </View>


            <View style={styles.formheader}>                <Text style={styles.titleform}>{t("Voltage")} ({t("V")})</Text></View>
            <View style={styles.form}>
                <Text style={styles.titleform}>{voltajfan}</Text>
                <Text style={styles.titleform}>{voltajfan2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{voltajfan3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{voltajfan4}</Text>

            </View>

            <View style={styles.formheader}>                <Text style={styles.titleform}>{t("Frequency")} ({t("Hz")})</Text></View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>{ferekans}</Text>
                <Text style={styles.titleform}>{ferekans2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{ferekans3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{ferekans4}</Text>

            </View>


            <View style={styles.formheader}>                <Text style={styles.titleform}>{t("Current")} ({t("A")})</Text></View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>{jaryanfan}</Text>
                <Text style={styles.titleform}>{jaryanfan2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{jaryanfan3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{jaryanfan4}</Text>

            </View>


            <View style={styles.formheader}>                <Text style={styles.titleform}>{t("Power")} ({t("KW")})</Text></View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>{tavanfan}</Text>
                <Text style={styles.titleform}>{tavanfan2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{tavanfan3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{tavanfan4}</Text>

            </View>




            <View style={styles.formheader}>                <Text style={styles.titleform}>{t("Inlet")}</Text></View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>{vorodireciver}</Text>
                <Text style={styles.titleform}>{vorodireciver2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{vorodireciver3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{vorodireciver4}</Text>

            </View>

            <View style={styles.formheader}>                <Text style={styles.titleform}>{t("Outlet")}</Text></View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>{khorojireciver}</Text>
                <Text style={styles.titleform}>{khorojireciver2}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{khorojireciver3}</Text>
                <Text style={[styles.titleform, { display: wd }]}>{khorojireciver4}</Text>

            </View>






        </SafeAreaView>

    )
}

export default CompCondonser;
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        backgroundColor: '#fff',
    }
    ,
    titleform: {
        marginBottom: 10,
        marginTop: 10,
        fontFamily: 'IranSans',
        fontSize: 13,
        flex: 1,
        textAlign: 'center'
    },
    viewform: {
        marginBottom: 10,
        marginTop: 10,
        flex: 1,
        textAlign: 'center',
    }
    ,
    inputtext: {
        backgroundColor: '#fff',
        textAlign: 'center',
        borderColor: "gray",
        width: "100%",
        borderWidth: 1,
        borderRadius: 10,
        padding: 10, width: '100%', height: 30
    }
    ,
    formheader: {
        width: '90%',
        backgroundColor: '#d7d7d7',
        margin: 2,
        padding: 5,
        justifyContent: 'center',
        alignItems: 'stretch',
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start'
    },
    dropdown: {
        height: 50,
        width: '100%',
        fontFamily: 'IranSans',
        fontSize: 13,
        borderWidth: 0,
        textAlign: 'center',
        backgroundColor: '#c9c9c9',
        direction: 'rtl',
        padding: 10,
    },
    form: {
        width: '90%',
        backgroundColor: '#ddd',
        margin: 2,
        padding: 5,
        justifyContent: 'center',
        alignItems: 'stretch',
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start'
    },
    formcomp: {
        width: '90%',

        marginTop: '-10px',
        padding: 3,
        justifyContent: 'center',
        alignItems: 'stretch',
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        marginBottom: 25
    },
    formodd: {
        width: '90%',
        backgroundColor: '#e6e6e6',
        margin: 2,
        padding: 5,
        justifyContent: 'center',
        alignItems: 'stretch',
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start'
    }
    ,
    header: {
        width: '90%',
        backgroundColor: '#022a4c',
        margin: 10,
        padding: 10,
        justifyContent: 'center',
        alignItems: 'stretch',
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 0.5 },
        shadowOpacity: 0.7,
        shadowRadius: 3,
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start'
    },
    titleheader: {
        marginBottom: 10,
        marginTop: 10,
        fontFamily: 'IranSans',
        fontSize: 14,
        flex: 1,
        textAlign: 'center',
        color: 'white'
    }
    ,
    touchable: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 12,
        paddingHorizontal: 32,
        borderRadius: 4,
        elevation: 3,
        backgroundColor: 'blue',
        marginBottom: 15,
        margin: 15,
    },
    titlebutton: {

        fontSize: 13,
        lineHeight: 21,
        fontWeight: 'bold',
        fontFamily: 'IranSans',
        letterSpacing: 0.25,
        color: 'white',
    }
    ,
    titlepicker: {
        fontSize: 14, fontFamily: 'IranSans', width: '90%', textAlign: 'right', padding: 7
    },
    centeredView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        marginTop: 10
    },
    modalView: {
        margin: 10,
        backgroundColor: "white",
        borderRadius: 20,
        padding: 15,
        width: '75%',
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5
    },
    button: {
        borderRadius: 20,
        padding: 10,
        elevation: 2
    },
    buttonOpen: {
        backgroundColor: "#F194FF",
    },
    buttonClose: {
        backgroundColor: "#06619b",
    },
    textStyle: {
        color: "white",
        fontWeight: 600,
        textAlign: "center",
        fontFamily: 'IranSans',
        fontSize: 14.1

    },
    modalText: {
        marginBottom: 10,
        textAlign: "center", fontFamily: 'IranSans', fontSize: 13.5,
    },
    spinner: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'black',
        bottom: 0,
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9000,
        opacity: 0.5,
    }
});